import React from 'react'

import { graphql } from '~/gql'
import { useGraphQLRequest } from '~/hooks/useGraphQLRequest'
import { exists } from '~/utils'

const document = graphql(`
  query UseSurveyBrandAccountQuery_Main($surveyId: ID!) {
    survey(id: $surveyId) {
      id
      brandAccountId
    }
  }
`)
export const useSurveyBrandAccountQueryFn = (surveyId: string | undefined) => {
  const graphQLRequest = useGraphQLRequest()

  return React.useCallback(async () => {
    if (!exists(surveyId)) {
      return null
    }

    return await graphQLRequest({ document, variables: { surveyId } })
  }, [graphQLRequest, surveyId])
}
